// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  maintenancesResponse: [],
};

const actions = {
  setReadMaintenancesCompany:
    (token, data, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/vehicles/static/read_maintenance?lang=${locale}`,
            options
          );

          const newMaintenance = await response.json();
          if (response.status === 200) {
            setState({ maintenancesResponse: newMaintenance });
            resolve(getState().maintenancesResponse);
          }

          if (response.status === 401) {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setMaintenancesCompany:
    (token, data, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/vehicles/static/maintenance?lang=${locale}`,
            options
          );

          const newMaintenance = await response.json();
          if (response.status === 200) {
            setState({ maintenancesResponse: newMaintenance });
            resolve(getState().maintenancesResponse);
          }

          if (response.status === 401) {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  setQualityService:
    (token, data, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch(
            `/api/bread/jwt/services/static/quality_service?lang=${locale}`,
            options
          );

          const res = await response.json();
          if (response.status === 200) {
            setState({ maintenancesResponse: res });
            resolve(getState().maintenancesResponse);
          }

          if (response.status === 401) {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  update:
    (token, data) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/services/static/update_service', options);
          const updateMaintenance = await response.json();

          if (response.status === 200) {
            setState({ response: updateMaintenance });
            resolve(getState().response);
          }

          if (response.status === 401) {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
  filter:
    (token, data) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/services/static/filter_service', options);
          const maintenance = await response.json();
          if (response.status === 200) {
            setState({ response: maintenance });
            resolve(getState().response);
          }

          if (response.status === 401) {
            reject(response);
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'maintenanceCompany',
});

export default createHook(Store);
